// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./en/metadata.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/en/metadata.json"); } },
  "./zh-CN/aiChat.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/aiChat.json"); } },
  "./zh-CN/builder.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/builder.json"); } },
  "./zh-CN/common.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/common.json"); } },
  "./zh-CN/covers.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/covers.json"); } },
  "./zh-CN/field.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/field.json"); } },
  "./zh-CN/login.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/login.json"); } },
  "./zh-CN/metadata.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/metadata.json"); } },
  "./zh-CN/scenes/form.json": { enumerable: true, get() { return require("/root/nextapp-service/src/locales/zh-CN/scenes/form.json"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;